<ion-header>
  <ion-toolbar class="header-color">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title class="toolbar-title">Verify Email</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="verify-email-body">
    <div class="row" *ngIf="hasSuccess">
        <div class="col-xs-12 col-sm-offset-1 col-sm-10">
            <h3>Verify your email</h3>
            <p *ngIf="!isVerifiedAnotherSession">Your email has been verified. You are being redirected to the home page.</p>
            <p *ngIf="isVerifiedAnotherSession">Your email has been verified. This session is belongs to another user. Please login with your account to continue.</p>
        </div>
    </div>
    <div class="row" *ngIf="!hasSuccess">
        <div class="col-xs-12 col-sm-offset-1 col-sm-10">
            <h3>Your email could not be verified.</h3>
        </div>
        <div class="col-xs-12 col-sm-offset-1 col-sm-10">
            <p class="text-danger">{{ error }}</p>
        </div>
    </div>
</div>

</ion-content>
